<template>
  <div class="union-login"></div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'union-login',

  customReadyNotify: true,

  data () {
    return {
      key: this.$route.query.key,
      channel: this.$route.query.channel || ''
    }
  },

  async created () {
    try {
      await this.unionLogin()
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },

  methods: {
    ...mapActions('user', ['fetchTokenX']),

    ...mapMutations('user', ['setUserInfo']),

    async unionLogin () {
      const response = await this.fetchTokenX({
        key: this.key
      })
      this.$bus.$emit('ready')
      if (response.success) {
        this.setUserInfo(response.data)
        if (this.channel === 'H5-xxqb') {
          this.$router.replace(`/newHumanity/result?channel=${this.channel}`)
        } else {
          this.$router.replace(`/authentication/result?channel=${this.channel}`)
        }
      } else {
        // this.$message(response.msg)
        if (this.channel === 'H5-xxqb') {
          this.$router.replace(`/landing/newHumanity/index?channel=${this.channel}`)
        } else {
          this.$router.replace(`/landing/interest?channel=${this.channel}`)
        }
      }
    }
  }
}
</script>